import type { FieldConfigOverride } from "../types";

export const DE_KYB_OVERRIDE: FieldConfigOverride = {
	id: "DE-any-kyb-v1",
	incorporationCountry: "DE",
	flowType: "KYB",
	version: "1.0.0",
	priority: 20,

	fieldOverrides: {
		entityType: {
			options: [
				{
					value: "GmbH",
					label: { en: "Gesellschaft mit beschränkter Haftung (GmbH)" },
				},
				{ value: "AG", label: { en: "Aktiengesellschaft (AG)" } },
				{ value: "UG", label: { en: "Unternehmergesellschaft (UG)" } },
				{ value: "OHG", label: { en: "Offene Handelsgesellschaft (OHG)" } },
				{ value: "KG", label: { en: "Kommanditgesellschaft (KG)" } },
				{
					value: "GbR",
					label: { en: "Gesellschaft bürgerlichen Rechts (GbR)" },
				},
				{
					value: "Einzelunternehmen",
					label: { en: "Einzelunternehmen (Sole Trader)" },
				},
			],
		},
		registrationNumber: {
			label: { en: "Handelsregisternummer (HRB/HRA)" },
			helpText: {
				en: "Your entry in the Handelsregister (Commercial Register). Format: HRB XXXXX",
			},
		},
		sanctionsScreening: {
			helpText: {
				en: "German entities must screen against EU consolidated sanctions list and BaFin requirements.",
			},
		},
	},

	additionalFields: [
		{
			fieldId: "vatId",
			step: 1,
			section: "company_basics",
			order: 65,
			label: { en: "VAT Identification Number (USt-IdNr.)" },
			type: "text",
			visible: true,
			required: true,
			validationRules: [
				{ type: "required", message: "VAT ID is required for German entities" },
				{
					type: "regex",
					value: "^DE\\d{9}$",
					message: "VAT ID must be in format DE followed by 9 digits",
				},
			],
			placeholder: { en: "DE123456789" },
			helpText: {
				en: "Your German VAT ID assigned by the Bundeszentralamt für Steuern.",
			},
		},
		{
			fieldId: "transparenzregisterEntry",
			step: 3,
			section: "ownership",
			order: 5,
			label: { en: "Transparenzregister Entry (UBO Register)" },
			type: "text",
			visible: true,
			required: false,
			validationRules: [],
			helpText: {
				en: "Reference number from the German Transparency Register (Transparenzregister), if applicable.",
			},
		},
	],

	// EU AMLD5/6: 25% UBO threshold
	uboDisclosureThreshold: 25,
};
